import { render } from "./ProjectPostedIcon.vue?vue&type=template&id=81e2d630"
import script from "./ProjectPostedIcon.vue?vue&type=script&lang=js"
export * from "./ProjectPostedIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__